import React, { useEffect, useState } from 'react';
import { 
    Dialog, 
    DialogTitle, 
    MuiThemeProvider, 
    Typography, 
    useMediaQuery, 
    useTheme, 
    TextField, 
    DialogActions, 
    InputAdornment 
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import { AiOutlineEdit } from 'react-icons/ai'
import MaskedInput from 'react-text-mask';
import { toast } from "react-toastify";

import LoadingButton from '../../../../Components/LoadingButton';

import { atualizarRelacaoPrevidenciaria } from '../../../../Store/Actions/API/relacoesPrevidenciariasActions';
import { formataCnpj, formataNit, removeCharactersAndSpecialCharacter, validarCNPJ } from '../../../../Utils/utils';
import temaFormulario from '../../../../Styles/Temas/temaFormulario';
import { useStyles } from './styles';

export default function ModalEditar({ cpf, relacaoSelecionada = {}, open, fechar }) {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const classes = useStyles();

    const [isLoading, setLoading] = useState(false);

    const [houveAlteracao, setHouveAlteracao] = useState(false);
    const [relacaoSelecionadaLocal, setRelacaoSelecionadaLocal] = useState({})
    const [erroCnpj, setErroCnpj] = useState('');
    const [erroOrigemVinculo, setErroOrigemVinculo] = useState('');

    useEffect(() => {
        setRelacaoSelecionadaLocal(relacaoSelecionada)
    }, []); // eslint-disable-line

    const onChangeCnpj = (event) => {
        let relacaoTemp = Object.assign({}, relacaoSelecionadaLocal);
        relacaoTemp.cnpjEmpregador = event.target.value;
        setRelacaoSelecionadaLocal(Object.assign({}, relacaoTemp));
        setHouveAlteracao(true);
    }

    const onChangeOrigemVinculo = (event) => {
        let relacaoTemp = Object.assign({}, relacaoSelecionadaLocal);
        relacaoTemp.origemVinculo = event.target.value;
        setRelacaoSelecionadaLocal(Object.assign({}, relacaoTemp));
        setHouveAlteracao(true);
    }

    const clicaConfirmar = async () => {
        let origemVinculoOk = (relacaoSelecionadaLocal.origemVinculo && relacaoSelecionadaLocal.origemVinculo.trim().length >= 3);
        let cnpjOk = validarCNPJ(relacaoSelecionadaLocal.cnpjEmpregador)
        if (cnpjOk && origemVinculoOk) {
            setLoading(true);

            let response = await atualizarRelacaoPrevidenciaria({
                cpf,
                entidadeBeneficente: relacaoSelecionadaLocal.entidadeBeneficente,
                origemVinculo: relacaoSelecionadaLocal.origemVinculo,
                cnpjEmpregador: removeCharactersAndSpecialCharacter(relacaoSelecionadaLocal.cnpjEmpregador),
                id: relacaoSelecionadaLocal.id
            });

            setLoading(false);

            if (response.sucesso) {
                fechar(relacaoSelecionadaLocal);
            }
        } else {
            if (!cnpjOk)
                setErroCnpj('Insira um CNPJ válido');
            if (!origemVinculoOk)
                setErroOrigemVinculo('Mínimo de 3 caracteres');

            toast.error('Verifique os dados inseridos!');
        }
    }

    return (
        <MuiThemeProvider theme={temaFormulario}>
            <Dialog
                fullScreen={fullScreen}
                fullWidth
                maxWidth={"xs"}
                open={open}
                onClose={fechar}
                aria-labelledby="modal-editar"
            >
                <DialogTitle id="modal-editar" style={{ backgroundColor: '#D4BFF9' }}>
                    <CloseIcon style={{ float: 'right', cursor: 'pointer' }} onClick={() => fechar()}>
                        <CloseIcon />
                    </CloseIcon>
                    <div>
                        <Typography style={{ fontSize: 11, paddingBottom: 3, paddingLeft: 2 }}>
                            {"Editando: Origem do Vínculo"}
                        </Typography>
                        <Typography style={{ fontWeight: 700, fontSize: 14 }}>
                            {relacaoSelecionada.origemVinculo ? `${relacaoSelecionada.origemVinculo}`.toUpperCase() : ''}
                        </Typography>
                    </div>
                </DialogTitle>
                <div className={classes.mainContent}>
                    <div className={classes.editableRow}>
                        <div className={classes.col1}>
                            <Typography className={classes.title}>Seq.:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <Typography className={classes.text}>{relacaoSelecionadaLocal.sequencia ?? '-'}</Typography>
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.col1}>
                            <Typography className={classes.title}>NIT:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <Typography className={classes.text}>{relacaoSelecionadaLocal.nit ? formataNit(relacaoSelecionadaLocal.nit) : '-'}</Typography>
                        </div>
                    </div>
                    <div className={classes.editableRow}>
                        <div className={classes.col1}>
                            <Typography className={classes.editableTitle}>Origem do Vínculo:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <TextField
                                color='secondary'
                                variant="outlined"
                                size='small'
                                margin='dense'
                                disabled={isLoading}
                                onChange={onChangeOrigemVinculo}
                                value={relacaoSelecionadaLocal.origemVinculo ?? ''}
                                onFocus={() => { setErroOrigemVinculo(''); toast.dismiss(); }}
                                style={{ width: 220, height: 35 }}
                                inputProps={{ style: { height: 35, fontSize: 13 } }}
                                InputProps={{ style: { height: 35, fontSize: 13, paddingLeft: 7 }, startAdornment: <InputAdornment> <AiOutlineEdit size={12} color='gray' /></InputAdornment> }}
                                hiddenLabel={true}
                                error={erroOrigemVinculo.length > 0}
                            />
                        </div>
                    </div>                    
                    <div className={classes.row}>
                        <div className={classes.col1}>
                            <Typography className={classes.title}>Código Empregador:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <Typography className={classes.text}>{relacaoSelecionadaLocal.codigoEmpregador ? formataCnpj(relacaoSelecionadaLocal.codigoEmpregador) : '-'}</Typography>
                        </div>
                    </div>
                    <div className={classes.editableRow}>
                        <div className={classes.col1}>
                            <Typography className={classes.editableTitle}>CNPJ Empregador:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <MaskedInput
                                mask={[/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/]}
                                placeholder="__.___.___/____-__"
                                onChange={onChangeCnpj}
                                value={relacaoSelecionadaLocal.cnpjEmpregador ?? ''}
                                onFocus={() => { setErroCnpj(''); toast.dismiss(); }}
                                render={(ref, props) => (
                                    <TextField
                                        color='secondary'
                                        variant="outlined"
                                        size='small'
                                        margin='dense'
                                        disabled={isLoading}
                                        style={{ width: 220, height: 35 }}
                                        inputProps={{ style: { height: 35, fontSize: 13 }, ...props }}
                                        InputProps={{ style: { height: 35, fontSize: 13, paddingLeft: 7 }, startAdornment: <InputAdornment> <AiOutlineEdit size={12} color='gray' /></InputAdornment> }}
                                        hiddenLabel={true}
                                        error={erroCnpj.length > 0}
                                        inputRef={ref}
                                    />
                                )} />
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.col1}>
                            <Typography className={classes.title}>Tipo Filiado no Vínculo:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <Typography className={classes.text}>{relacaoSelecionadaLocal.tipoFiliadoVinculo ?? '-'}</Typography>
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.col1}>
                            <Typography className={classes.title}>Cooperado:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <Typography className={classes.text}>{relacaoSelecionadaLocal.cooperado ? 'Sim' : 'Não'}</Typography>
                        </div>
                    </div>
                    <div className={classes.row}>
                        <div className={classes.col1}>
                            <Typography className={classes.title}>Entidade Beneficiente:</Typography>
                        </div>
                        <div className={classes.col2}>
                            <Typography className={classes.text}>{relacaoSelecionadaLocal.entidadeBeneficente ? 'Sim' : 'Não'}</Typography>
                        </div>
                    </div>
                </div>
                <DialogActions id="modal-editar" style={{ paddingRight: 20, paddingBottom: 15, paddingTop: 0 }}>
                    <LoadingButton
                        id="button_confirmar"
                        variant="contained"
                        color="primary"
                        size='small'
                        disabled={!houveAlteracao}
                        onClick={clicaConfirmar}
                        loading={isLoading}
                        disableElevation
                    >
                        Confirmar
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </MuiThemeProvider>
    )
}